import React, { useState } from "react";
import { useSelector } from "react-redux";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import useMediaQuery from "@/hooks/use-media-query/use-media-query-enhanced";
import { RootState } from "@/store/root-reducer";

import PriceDrawer from "./price-drawer";

type LastYearPriceProps = {
  cmsData: {
    lastYearPriceTitle: string;
    renewalPriceTitle: string;
    renewalPriceDiscountText: string;
    renewalPriceClickableText: string;
    renewalPriceClickableTextMobile: string;
    moreInfoButtonLabel: string;
    moreInfoDrawerTitle: string;
    moreInfoDrawerContent: string;
    renewalPriceDrawerTitle: string;
    renewalPriceDrawerContent: string;
    closeButtonDrawer: string;
    infoText: string;
  };
};

function LastYearPrice({ cmsData }: Readonly<LastYearPriceProps>) {
  const {
    lastYearPriceTitle,
    renewalPriceTitle,
    renewalPriceDiscountText,
    renewalPriceClickableText,
    renewalPriceClickableTextMobile,
    moreInfoButtonLabel,
    moreInfoDrawerTitle,
    moreInfoDrawerContent,
    renewalPriceDrawerContent,
    renewalPriceDrawerTitle,
    closeButtonDrawer,
    infoText,
  } = cmsData;

  const [isdesktop, isReady] = useMediaQuery("(min-width: 600px)");
  const [isLastYearDrawerOpen, setIsLastYearDrawerOpen] = useState(false);
  const [isRenewalDrawerOpen, setIsRenewalDrawerOpen] = useState(false);
  const { attributes } = useSelector((state: RootState) => state.quote);
  const { priceResult, paymentDetails } = attributes;

  if (!isReady) return null;

  return (
    <div>
      <div className="flex justify-between items-start pb-spacing-xs lg:pb-spacing-xs ">
        <div>
          <p className="font-body-font text-2xs font-[400] leading-[24px] text-text-functional-subtle">
            {lastYearPriceTitle}
          </p>
        </div>

        <div className=" h-[24px]">
          <LabelButtonWrapper
            label={moreInfoButtonLabel}
            hierarchy="tertiary"
            className="font-body-font leading-[18px] font-[600] realtive text-xs top-[-8px] !px-spacing-xxs"
            onClick={() => setIsLastYearDrawerOpen(true)}
          />
        </div>
      </div>

      <div>
        <p className="font-body-font text-xs font-[700] leading-[27px] text-interactive-secondary-default pb-spacing-s">
          £
          {priceResult?.renewalPolicyPackage?.lastYearPrice.toFixed(2) ?? "N/A"}
        </p>
      </div>

      <div>
        <p className="font-body-font text-2xs font-[400] leading-[24px] text-text-functional-subtle">
          {renewalPriceTitle}
        </p>
        <p className="font-body-font text-xs font-[700] leading-[27px] text-interactive-secondary-default">
          £{paymentDetails?.paymentOptions[0].cardPayment.card.price ?? " N/A"}
          {priceResult?.renewalPolicyPackage?.loyaltyDiscountEligible && (
            <span className="line-through font-[400] pl-[10px]">
              £
              {priceResult?.renewalPolicyPackage?.finalRetailENBPrice.toFixed(
                2
              ) ?? " N/A"}
            </span>
          )}
        </p>
        {priceResult?.renewalPolicyPackage?.loyaltyDiscountEligible && (
          <p className="text-2xs font-[400] font-body-font leading-[24px] text-text-body pb-spacing-xs">
            {renewalPriceDiscountText}&nbsp;
            <strong className="font-[700]">
              £
              {priceResult?.renewalPolicyPackage?.loyaltySavingAmount ?? " N/A"}
            </strong>
          </p>
        )}
        {priceResult?.renewalPolicyPackage?.lastYearPrice &&
          Number(priceResult.renewalPolicyPackage.lastYearPrice) <
            Number(
              paymentDetails?.paymentOptions[0].cardPayment.card.price
            ) && (
            <LabelButtonWrapper
              label={
                isdesktop
                  ? renewalPriceClickableText
                  : renewalPriceClickableTextMobile
              }
              hierarchy="tertiary"
              className="font-body-font leading-[18px] font-[600] text-xs realtive top-[-4px] right-[-4px] md:right-[0] !px-[0px]"
              onClick={() => setIsRenewalDrawerOpen(true)}
            />
          )}
        <p className="text-3xs font-[400] font-body-font leading-[21px] text-text-functional-1 text-left pt-spacing-m md:pt-spacing-s">
          {infoText}
        </p>
      </div>
      <PriceDrawer
        isOpen={isLastYearDrawerOpen}
        onClose={() => setIsLastYearDrawerOpen(false)}
        drawerTitle={moreInfoDrawerTitle}
        drawerContent={moreInfoDrawerContent}
        closeButtonDrawer={closeButtonDrawer}
      />
      <PriceDrawer
        isOpen={isRenewalDrawerOpen}
        onClose={() => setIsRenewalDrawerOpen(false)}
        drawerTitle={renewalPriceDrawerTitle}
        drawerContent={renewalPriceDrawerContent}
        closeButtonDrawer={closeButtonDrawer}
      />
    </div>
  );
}

export default LastYearPrice;
